import React from "react";
import { NavLink } from "react-router-dom";
import { HiOutlineBars3 } from "react-icons/hi2";
import "./mobileNav.css";

/**
 * Phone bottom bar: up to four pinned destinations plus Menu. Which four is
 * decided by getPrimaryTabs (per persona), not by array order.
 */
const BottomTabBar = ({ tabs, menuActive, menuOpen, onMenu, menuTriggerRef }) => (
  <nav className="mnav-bar" aria-label="Main">
    {tabs.map((tab) => {
      const Icon = tab.icon;
      return (
        <NavLink
          key={tab.key}
          to={tab.to}
          end={tab.end}
          className={({ isActive }) => `mnav-tab${isActive ? " is-active" : ""}`}
          aria-label={tab.label}
        >
          <span className="mnav-tab-icon">
            <Icon size={24} />
          </span>
          <span className="mnav-tab-label">{tab.label}</span>
        </NavLink>
      );
    })}

    <button
      ref={menuTriggerRef}
      type="button"
      className={`mnav-tab${menuOpen || menuActive ? " is-active" : ""}`}
      onClick={onMenu}
      aria-haspopup="dialog"
      aria-expanded={menuOpen}
      aria-label="Menu"
    >
      <span className="mnav-tab-icon">
        <HiOutlineBars3 size={26} />
      </span>
      <span className="mnav-tab-label">Menu</span>
    </button>
  </nav>
);

export default BottomTabBar;
